module.exports = __webpack_public_path__ + "static/media/logo-przelewy-24-blik.2cbd51f8.svg";